import { Injectable } from '@angular/core';
import { supabase } from './supabase.client';

@Injectable({
  providedIn: 'root'
})
export class SupabaseService {
  private userCache: any = null;
  private lastUserFetch = 0;

  async signUp(email: string, password: string) {
    const { data, error } = await supabase.auth.signUp({
      email,
      password
    });
    return { data, error };
  }

  async signIn(email: string, password: string) {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password
    });
    if (!error) {
      this.userCache = data?.user;
    }
    return { data, error };
  }

  async signOut() {
    this.userCache = null;
    const { error } = await supabase.auth.signOut();
    return { error };
  }

  async getUser() {
    // Use cache if called within 1 second to prevent lock timeouts
    const now = Date.now();
    if (this.userCache && now - this.lastUserFetch < 1000) {
      return { data: { user: this.userCache }, error: null };
    }

    const { data, error } = await supabase.auth.getUser();
    
    if (!error && data?.user) {
      this.userCache = data.user;
      this.lastUserFetch = now;
    }
    
    return { data, error };
  }

  async getSession() {
    const { data, error } = await supabase.auth.getSession();
    return { data, error };
  }
}
